<template>
  <button
    @click="$emit('click')"
    type="button"
    :class="'btn btn-' + buttonClass + ' icon-left'"
  >
    <i :class="iconClass"></i> {{ providerLabel }}
  </button>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String,
      required: true
    },
    providerLabel: {
      type: String,
      required: true
    }
  }
};
</script>
